import wixWindow from "wix-window";

const LOG_ANALYTICS = true;
const DEBUG_LOG_ANALYTICS = true;
const APP_NAME = "evolve";
const APP_VERSION = 95; // Major * 100 + Minor

class Analytics {

  static trackLaunch() {
    this.track(
      "App launched",
      {
        appName: APP_NAME,
        appVersion: APP_VERSION,
      },
      "Lifecycle"
    );
  }

  static trackStarting() {
    this.track("Speechly starting", {}, "Lifecycle");
  }

  static trackInitialized(success, status) {
    const eventName = success ? "Speechly initialized" : "Speechly failed";
    this.track(
      eventName,
      {
        success,
        status,
        appName: APP_NAME,
        appVersion: APP_VERSION,
      },
      "Lifecycle",
      status
    );
  }

  static trackSpeechlyAction(eventName, detail) {
    this.track(
      eventName,
      {
        detail: detail,
      },
      "Speechly Ecommerce",
      detail
    );
  }

  static trackSpeechlyQA(eventName, segment) {
    const transcript = segment.words.map((w) => w.value).join(" ");
    this.track(
      eventName,
      {
        transcript: transcript,
      },
      "Speechly QA",
      transcript
    );
  }

  // static track(eventName: string, eventParams: {}) {
  static track(
    eventName,
    eventParams,
    gaEventCategory,
    gaEventLabel = undefined
  ) {
    if (DEBUG_LOG_ANALYTICS) {
      console.log(`[ANALYTICS] ${eventName}`, eventParams);
    }
    if (LOG_ANALYTICS) {
      wixWindow.trackEvent("CustomEvent", {
        event: "Speechly",  // eventName,
        eventCategory: gaEventCategory, // Visible in GA
        eventAction: eventName, // Visible in GA
        eventLabel: gaEventLabel, // Visible in GA by clicking "eventCategory"
      });

      // const Segment = window.analytics;
      // window.analytics may be undefined at first load since we inject the prop inside Google Tag Manager
      // if (Segment) Segment.track(eventName, eventParams);
    }
  }

  static page(
    eventName = undefined,
    eventParams = undefined
  ) {
    /*
    if (DEBUG_LOG_ANALYTICS) {
      console.log(`[ANALYTICS] PAGE ${eventName}`, eventParams);
    }
    if (LOG_ANALYTICS) {
      const Segment = wixWindow.analytics;
      console.log(Segment);
      // window.analytics may be undefined at first load since we inject the prop inside Google Tag Manager
      if (Segment) Segment.page(eventName, eventParams);
    }
    */
  }
}

export default Analytics;
